import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useAuth } from '../context/AuthContext';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dumbbell } from 'lucide-react';

const RegisterPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = 'Create Account | Axon Muscle';
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.firstName || !formData.email || !formData.password) {
      setError('Please fill in all required fields');
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    login({ 
      email: formData.email, 
      firstName: formData.firstName, 
      lastName: formData.lastName 
    });
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-neutral-950">
      <Header />
      
      <main className="pt-[140px] pb-20">
        <div className="max-w-md mx-auto px-6">
          <div className="text-center mb-10">
            <div className="w-16 h-16 bg-gradient-to-br from-axon-600 to-axon-500 rounded-xl flex items-center justify-center mx-auto mb-6">
              <Dumbbell className="w-8 h-8 text-white" />
            </div>
            <h1 className="font-display text-3xl text-white uppercase tracking-tight mb-2">Create Account</h1>
            <p className="text-neutral-400">Join the Titan community</p>
          </div>
          
          <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              {error && (
                <div className="p-3 bg-red-500/10 border border-red-500/30 text-red-500 text-sm rounded-xl">
                  {error}
                </div>
              )}
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-sm font-semibold text-white">First Name *</Label>
                  <Input
                    type="text"
                    value={formData.firstName}
                    onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                    className="mt-2 bg-neutral-800 border-neutral-700 text-white placeholder-neutral-500 focus:ring-axon-500 focus:border-axon-500 rounded-xl"
                  />
                </div>
                <div>
                  <Label className="text-sm font-semibold text-white">Last Name</Label>
                  <Input
                    type="text"
                    value={formData.lastName}
                    onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                    className="mt-2 bg-neutral-800 border-neutral-700 text-white placeholder-neutral-500 focus:ring-axon-500 focus:border-axon-500 rounded-xl"
                  />
                </div>
              </div>
              
              <div>
                <Label className="text-sm font-semibold text-white">Email *</Label>
                <Input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="mt-2 bg-neutral-800 border-neutral-700 text-white placeholder-neutral-500 focus:ring-axon-500 focus:border-axon-500 rounded-xl"
                  placeholder="your@email.com"
                />
              </div>
              
              <div>
                <Label className="text-sm font-semibold text-white">Password *</Label>
                <Input
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  className="mt-2 bg-neutral-800 border-neutral-700 text-white placeholder-neutral-500 focus:ring-axon-500 focus:border-axon-500 rounded-xl"
                  placeholder="••••••••"
                />
              </div>
              
              <div>
                <Label className="text-sm font-semibold text-white">Confirm Password *</Label>
                <Input
                  type="password"
                  value={formData.confirmPassword}
                  onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                  className="mt-2 bg-neutral-800 border-neutral-700 text-white placeholder-neutral-500 focus:ring-axon-500 focus:border-axon-500 rounded-xl"
                  placeholder="••••••••"
                />
              </div>
              
              <button 
                type="submit" 
                className="w-full py-4 bg-gradient-to-r from-axon-600 to-axon-500 hover:from-axon-500 hover:to-axon-400 text-white font-bold uppercase tracking-wider rounded-xl transition-all shadow-button"
              >
                Create Account
              </button>
            </form>
          </div>
          
          <p className="text-center mt-6 text-neutral-400 text-sm">
            Already have an account?{' '}
            <Link to="/login" className="text-axon-500 font-medium hover:text-axon-400">
              Sign in
            </Link>
          </p>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default RegisterPage;
